<form #form="ngForm" (ngSubmit)="save(form)">
  <!-- Row 1 -->
  <div class="p-fluid p-formgrid-del p-grid p-mt-2">
    <!--Activity Date-->
    <div class="p-field p-col-12 p-md-5">
      <span class="p-float-label">
        <p-calendar class="p-inputtext-sm" 
                    appendTo="body"
                    showIcon="true" 
                    dateFormat="dd/mm/yy"
                    inputId="activityDate"
                    name="activityDate"
                    #activityDate="ngModel"
                    required
                    [(ngModel)]="activityModel.activityDate"
                    [class.field-error]="form.submitted && activityDate.invalid"></p-calendar>
        <label for="activityDate">Date</label>
      </span>
      <small class="p-error" *ngIf="form.submitted && activityDate.invalid">Date is required!</small>
    </div>
  </div> 

  <div class="p-fluid p-formgrid-del p-grid p-mt-2">
    <!--Activity Date-->
    <div class="p-field p-col-12">
      <span class="p-float-label">
        <textarea pInputTextarea
                  id="activityNote"
                  name="activityNote"
                  class="p-inputtext-sm"
                  rows="3"
                  #activityNote="ngModel"
                  [(ngModel)]="activityModel.note"
                  [class.field-error]="form.submitted && activityNote.invalid"></textarea>
        <label for="activityNote" class="required-field">Note</label>
      </span>
      <small class="p-error" *ngIf="form.submitted && activityNote.invalid">Note field cannot be empty!</small> 
    </div>
  </div> 
  
  <div>
    <pps-employee-history [employeeId]="activityModel.employeeId"></pps-employee-history>    
  </div>

  <div class="modal-footer">
    <button pButton pRipple label="Save" class="p-button" icon="pi pi-save" type="submit"></button>
    <button pButton pRipple label="Cancel" class="p-button" icon="pi pi-times" type="button" (click)="cancel()"></button>
  </div>
</form>
